import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'REPORTS_ARQUIVO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'REPORTS_ARQUIVO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('reportsArquivoForm', registro)
    ];
}

export function getLista(shipping, solicitacao) {
	return (dispatch, getState) => {
		
		dispatch({
			type: 'REPORTS_ARQUIVO_LISTADO',
			payload: { data: [] }
		});

    	axios.get(`${consts.API_DATALAKE_URL}/reportsArquivo?shipping=${shipping || 0}`)
		.then(resp => {
			dispatch({
		        type: 'REPORTS_ARQUIVO_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_DATALAKE_URL}/reportsArquivo`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.shipping, registro.solicitacao || null));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_DATALAKE_URL}/reportsArquivo`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.shipping, registro.solicitacao || null));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_DATALAKE_URL}/reportsArquivo?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista(registro.shipping, registro.solicitacao || null));
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getDownload(id) {
	return (dispatch, getState) => {
		
		axios.get(`${consts.API_DATALAKE_URL}/reportsArquivo/download?id=${id || 0}`)
		.then(resp => {
			if (resp.data && resp.data.base64) {

				if (window.confirm('O arquivo foi carregado com sucesso. Deseja baixá-lo agora?')) {
					// Converte Base64 para byte array
					const byteCharacters = atob(resp.data.base64);
					const byteNumbers = new Array(byteCharacters.length);
					for (let i = 0; i < byteCharacters.length; i++) {
					byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					const byteArray = new Uint8Array(byteNumbers);
		
					// Cria Blob
					const blob = new Blob([byteArray]);
		
					// Cria link temporário
					const link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.download = `${resp.data.nome}.${resp.data.extensao || ''}`;
					link.click();
		
					// Libera memória
					window.URL.revokeObjectURL(link.href);
				}
			}
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getDownloadAll(shipping, solicitacao) {
	return (dispatch, getState) => {
		
		axios.get(`${consts.API_DATALAKE_URL}/reportsArquivo/downloadAll?shipping=${shipping || 0}`)
		.then(resp => {
			if (resp.data && resp.data.file) {

				// Cria link temporário
				const link = document.createElement("a");
				link.href = `${consts.URL}/${resp.data.file}`;
				link.target = 'blank';
				link.download = resp.data.filename;
				link.click();
	  
				// Libera memória
				window.URL.revokeObjectURL(link.href);
			  }			
		}).catch(e => {
			setErroAPI(e);
		});
	}
}